{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Új üzenet",
  "chat.scrollToBottom": "Görgess le az alulra",
  "messagefeedback.thumbDown": "Rossz válasz",
  "messagefeedback.thumbUp": "Jó válasz",
  "promptfield.aiDisclaimer": "A válaszokat mesterséges intelligencia segítségével generálják, és előfordulhat, hogy pontatlanok. Ellenőrizd a használat előtt.",
  "promptfield.aiUserGuidlines": "AI felhasználói irányelvek",
  "promptfield.attachments": "Mellékletek",
  "promptfield.insertButton": "Add",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Készen áll a kezdésre? Tegyen fel egy kérdést, ossza meg az ötletét, vagy adjon hozzá egy feladatot.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Állj meg",
  "promptfield.submitButton": "Elküldöm",
  "promptfield.uploading": "Feltöltés",
  "responsestatus.loading": "Betöltés folyamatban",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Kezdj el felvételt",
  "voicebutton.stopListening": "Felvétel abbahagyása",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
